import React from "react";

import {NutritionInfo} from "@apps/dish/interfaces";

import styles from "./NutritionInfosSection.scss";

type NutritionInfosSectionProps = {
  nutritionInfos: NutritionInfo[];
};

export default function NutritionInfosSection({
  nutritionInfos,
}: NutritionInfosSectionProps): JSX.Element {
  return (
    <>
      {nutritionInfos.map((nutritionInfo) => (
        <table className={styles.nutritionInfoTable} key={nutritionInfo.name}>
          <caption>
            <b>{nutritionInfo.name}</b>
          </caption>
          <tbody>
            {nutritionInfo.nutrition?.map((nutrition) => (
              <tr key={nutrition.name}>
                <th scope="row">{nutrition.name}:</th>
                <td> {nutrition.amount_in_unit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </>
  );
}
